import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";

const Thank_You = () => {
  return (
    <>
      <div
        className="page-template-default page page-id-2585 desktop desktop-menu mobile-menu-push-to-left header-sticky-both wide 
                            page-has-no-sidebar title-bar-none woocommerce elementor-default elementor-kit-22 elementor-page elementor-page-2585 e--ua-blink 
                            e--ua-chrome e--ua-webkit loaded"
        data-elementor-device-mode="desktop"
      >
        <Header />
        <div
          className="d-flex flex-column justify-content-center align-items-center  bg-light text-center "
          style={{
            marginTop: "200px",
          }}
        >
          <h1 className="display-1 text-success mb-0">Thank You!</h1>
          <p className="lead">Your query has been successfully submitted.</p>
          <Link to="/" className="btn btn-primary mt-0 mb-5">
            Back to Home
          </Link>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Thank_You;
